<section *ngIf="dados" class="vinculos">
  <div *ngIf="dados.produto.local.codigoPdv !== dados.produto.externo.codigoPdv" class="decisao-pdv decisao-pdv--produto">
    <strong>Qual código PDV manter no produto?</strong>
    <label><input type="radio" name="pdv-produto" value="LOCAL" [disabled]="salvando || !dados.produto.local.codigoPdv"
      [(ngModel)]="camposProduto.codigoPdv"> Local: {{ dados.produto.local.codigoPdv || 'não informado' }}</label>
    <label><input type="radio" name="pdv-produto" value="IFOOD" [disabled]="salvando || !dados.produto.externo.codigoPdv"
      [(ngModel)]="camposProduto.codigoPdv"> {{ nomePlataforma }}: {{ dados.produto.externo.codigoPdv || 'não informado' }}</label>
  </div>

  <div class="map-header">
    <small>Mapeamento hierárquico</small>
    <h3>Adicionais e opções</h3>
    <p>Associe apenas itens que já existem nos dois catálogos. Preços são exibidos somente para conferência.</p>
  </div>
  <p *ngIf="!dados.gruposLocais.length" class="vazio">Este produto não tem adicionais locais para vincular.</p>

  <article *ngFor="let local of dados.gruposLocais" class="grupo">
    <header class="grupo__header">
      <div class="grupo__local">
        <small>Grupo local #{{ local.id }}</small>
        <strong>Adicional local: <span>{{ local.nome }}</span></strong>
      </div>
      <span class="ligacao fa fa-link" aria-hidden="true"></span>
      <div class="grupo__remote">
        <label [attr.for]="'grupo-remoto-' + local.id">Correspondente {{ nomePlataforma }}</label>
        <select [id]="'grupo-remoto-' + local.id" [ngModel]="grupoExternoParaLocal(local)?.id || null"
          (ngModelChange)="selecioneGrupoParaLocal(local, $event)" [disabled]="salvando">
          <option [ngValue]="null">Sem vínculo nesta etapa</option>
          <option *ngFor="let remoto of gruposExternosDisponiveis(local)" [ngValue]="remoto.id">
            {{ nomePlataforma }}: {{ remoto.nome }}
          </option>
        </select>
      </div>
    </header>

    <p *ngIf="local.compartilhado && grupoExternoParaLocal(local)" class="nota">
      Adicional compartilhado: escolher o PDV do {{ nomePlataforma }} para uma opção altera seu código nos outros produtos locais que a utilizam.
    </p>

    <div class="opcoes" *ngIf="local.opcoes.length">
      <div class="opcoes__cabecalho">
        <span>Opção local · PDV / preço</span><span>Status</span><span>Correspondente {{ nomePlataforma }} · PDV / preço</span>
      </div>
      <div *ngFor="let opcao of local.opcoes" class="opcao">
        <div class="opcao__linha">
          <div class="opcao__local">
            <strong>{{ opcao.nome }} <code>{{ opcao.codigoPdv || 'sem PDV' }}</code></strong>
            <small>Preço local: {{ opcao.precoLocal != null
              ? (opcao.precoLocal | currency:'BRL':'symbol':'1.2-2':'pt') : '—' }}</small>
          </div>
          <div class="opcao__status">
            <ng-container *ngIf="opcaoExternaParaLocal(grupoExternoParaLocal(local), opcao.id) as correspondente; else opcaoSemPar">
              <span *ngIf="opcao.codigoPdv === correspondente.codigoPdv" class="fa fa-check estado--ok"
                aria-label="Vinculada" title="Vinculada"></span>
              <span *ngIf="opcao.codigoPdv !== correspondente.codigoPdv && !camposOpcao[correspondente.id]?.codigoPdv"
                class="fa fa-question-circle estado--pendente" aria-label="Decidir PDV" title="Decidir PDV"></span>
              <span *ngIf="opcao.codigoPdv !== correspondente.codigoPdv && camposOpcao[correspondente.id]?.codigoPdv"
                class="fa fa-check estado--ok" aria-label="PDV definido" title="PDV definido"></span>
            </ng-container>
            <ng-template #opcaoSemPar>
              <span *ngIf="opcoesExternasDisponiveis(grupoExternoParaLocal(local), opcao.id).length"
                class="fa fa-question-circle estado--pendente" aria-label="Escolher correspondência"
                title="Escolher correspondência"></span>
              <span *ngIf="grupoExternoParaLocal(local) && !opcoesExternasDisponiveis(grupoExternoParaLocal(local), opcao.id).length"
                class="fa fa-times-circle estado--sem-par" aria-label="Sem correspondente" title="Sem correspondente"></span>
              <span *ngIf="!grupoExternoParaLocal(local)" class="estado--sem-par" title="Vincule o adicional primeiro">—</span>
            </ng-template>
          </div>
          <div class="opcao__remote">
            <select [attr.aria-label]="'Correspondente no ' + nomePlataforma + ' para ' + opcao.nome"
              [ngModel]="opcaoExternaParaLocal(grupoExternoParaLocal(local), opcao.id)?.id || null"
              (ngModelChange)="selecioneOpcaoParaLocal(grupoExternoParaLocal(local), opcao.id, $event)"
              [disabled]="salvando || !grupoExternoParaLocal(local)"
              [class.opcao__select--ok]="!!opcaoExternaParaLocal(grupoExternoParaLocal(local), opcao.id)"
              [class.opcao__select--pendente]="!!grupoExternoParaLocal(local) &&
                !opcaoExternaParaLocal(grupoExternoParaLocal(local), opcao.id) &&
                !!opcoesExternasDisponiveis(grupoExternoParaLocal(local), opcao.id).length"
              [class.opcao__select--sem-par]="!!grupoExternoParaLocal(local) &&
                !opcaoExternaParaLocal(grupoExternoParaLocal(local), opcao.id) &&
                !opcoesExternasDisponiveis(grupoExternoParaLocal(local), opcao.id).length">
              <option [ngValue]="null">{{ !grupoExternoParaLocal(local) ? 'Selecione o adicional acima' :
                (opcoesExternasDisponiveis(grupoExternoParaLocal(local), opcao.id).length
                  ? '— Vincular ' + opcao.nome + ' no ' + nomePlataforma + ' —' : 'Sem correspondente no ' + nomePlataforma) }}</option>
              <option *ngFor="let remota of opcoesExternasDisponiveis(grupoExternoParaLocal(local), opcao.id)"
                [ngValue]="remota.id">{{ nomePlataforma }}: {{ remota.nome }} ({{ remota.codigoPdv || 'sem PDV' }}) |
                {{ precoExibicao(remota.campos) != null
                  ? (precoExibicao(remota.campos) | currency:'BRL':'symbol':'1.2-2':'pt') : '—' }}</option>
            </select>
          </div>
        </div>
        <ng-container *ngIf="opcaoExternaParaLocal(grupoExternoParaLocal(local), opcao.id) as correspondente">
          <div *ngIf="opcao.codigoPdv !== correspondente.codigoPdv" class="decisao-pdv decisao-pdv--opcao">
            <strong>Qual código PDV manter para “{{ opcao.nome }}”?</strong>
            <label><input type="radio" [name]="'pdv-opcao-' + correspondente.id" value="LOCAL"
              [disabled]="salvando || !opcao.codigoPdv" [(ngModel)]="camposOpcao[correspondente.id].codigoPdv">
              Local: {{ opcao.codigoPdv || 'não informado' }}</label>
            <label><input type="radio" [name]="'pdv-opcao-' + correspondente.id" value="IFOOD"
              [disabled]="salvando || !correspondente.codigoPdv" [(ngModel)]="camposOpcao[correspondente.id].codigoPdv">
              {{ nomePlataforma }}: {{ correspondente.codigoPdv || 'não informado' }}</label>
          </div>
        </ng-container>
      </div>
    </div>
    <div *ngIf="opcoesExternasSemCorrespondencia(grupoExternoParaLocal(local)).length" class="ignorados">
      <strong>Opções do {{ nomePlataforma }} sem vínculo nesta etapa</strong>
      <span *ngFor="let opcao of opcoesExternasSemCorrespondencia(grupoExternoParaLocal(local))">{{ opcao.nome }}</span>
    </div>
  </article>

  <div *ngIf="gruposExternosSemCorrespondencia().length" class="ignorados">
    <strong>Adicionais do {{ nomePlataforma }} sem vínculo nesta etapa</strong>
    <span *ngFor="let grupo of gruposExternosSemCorrespondencia()">{{ grupo.nome }}</span>
  </div>
  <p *ngIf="erro" class="erro" role="alert">{{ erro }}</p>
  <footer>
    <span>Esta etapa não envia dados ao {{ nomePlataforma }} nem gera pendências de publicação.</span>
    <button type="button" *ngIf="mostrarVoltar" (click)="cancelar.emit()" [disabled]="salvando">Voltar</button>
    <button type="button" class="principal" [disabled]="!podeConfirmar()" (click)="confirme()">Confirmar vínculos</button>
  </footer>
  <p *ngIf="!podeConfirmar()" class="aviso">Escolha os códigos PDV divergentes para continuar.</p>
</section>
